import { Module } from "vuex";
import { actions, AUTH_ACTIONS } from "./actions";
import { getters, AUTH_GETTERS } from "./getters";
import { mutations, AUTH_MUTATIONS } from "./mutations";
import { IAuthState } from "./types";
import { IRootState } from "@/store/types";

export const state: IAuthState = {
  user: undefined,
  roles: undefined,
  isAuthenticated: false,
  issuedRoles: [],
  isAssumingRole: false
};

export namespace AUTH {
  export const ACTIONS: any = AUTH_ACTIONS;
  export const GETTERS: any = AUTH_GETTERS;
  export const MUTATIONS: any = AUTH_MUTATIONS;
  export const NAME_SPACE: string = "auth";
  export const NS = (x: string): string => `${NAME_SPACE}/${x}`;
}

const namespaced: boolean = true;

export const auth: Module<IAuthState, IRootState> = {
  namespaced,
  state,
  getters,
  mutations,
  actions
};
